import { SupportedLang, TRANSLATIONS } from 'src/app/utils/translations/translations';

export function resolveLocale(raw: string | null | undefined): SupportedLang {
  const primarySubtag = (raw ?? '').toLowerCase().split('-')[0];

  return primarySubtag in TRANSLATIONS ? (primarySubtag as SupportedLang) : 'en';
}
